import React from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import { useRouter } from 'next/router';
import Head from 'next/head';

import { Company as CompanyView } from 'components/views/Company';
import { faqCompany } from 'content/faq';
import { StrapiService } from 'lib/strapi/StrapiService';
import { MagazineArticleCard } from 'components/sections/Magazine';
import { MarketplaceAdsResponse } from 'types/MarketplaceAdsResponse';
import { getMarketplaceAdsParams } from 'utils/marketplaceAdsFilter';
import { useVehicleData } from 'lib/api/swr/useVehiclesData';

interface Props {
  articles: MagazineArticleCard[];
  marketplaceAds: MarketplaceAdsResponse;
}

const Company: NextPage<Props> = ({ articles, marketplaceAds }) => {
  const router = useRouter();

  const canonicalUrl = `https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}${router.asPath}`;
  const marketplaceAdsParams = getMarketplaceAdsParams({
    perPage: 10,
    filters: {
      tag: '',
      is_company_leasable: true,
    },
  });
  const {
    data: clientSideData,
    isLoading,
    error,
  } = useVehicleData(marketplaceAdsParams, marketplaceAds);

  return (
    <>
      <Head>
        <title>Blipp för företag - Blipp</title>
        <meta property="og:title" content="Blipp för företag  - Blipp" />
        <meta
          property="og:description"
          content="Hos oss kan du läsa mer om vilka tjänster vi erbjuder dig som företagare. Blipp hjälper dig att göra trygga & smidiga bilaffärer utan krångel."
        />
        <meta
          name="description"
          content="Hos oss kan du läsa mer om vilka tjänster vi erbjuder dig som företagare. Blipp hjälper dig att göra trygga & smidiga bilaffärer utan krångel."
        />
        <link rel="canonical" key="canonical" href={canonicalUrl} />
      </Head>
      <CompanyView
        faqCompanyLeasing={faqCompany}
        articles={articles}
        isLoading={isLoading}
        error={error}
        marketplaceAds={clientSideData}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const articles = await StrapiService.getLatestMagazineArticles(3);

  return {
    props: {
      articles,
    },
  };
};

export default Company;
